var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysAir = function SvgSysAir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#sysAir_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2Zm0-2a12 12 0 1 1 0 24 12 12 0 0 1 0-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.586 16.806a2.582 2.582 0 0 1-2.3-1.171.5.5 0 0 1 .086-.6l.356-.348-1.077-1.057a.5.5 0 0 1 .13-.807l1.445-.706a.5.5 0 0 1 .374-.026l1.975.643 2.07-1.011-3.1-3.032a.5.5 0 0 1 .35-.858H9.06a.5.5 0 0 1 .22.051l4.151 2.028 4.12-1.341a2.52 2.52 0 0 1 .984-.209 1.943 1.943 0 0 1 1.812 1.171c.147.307.183.656.1.987a.668.668 0 0 1-.349.384L7.821 16.549c-.388.173-.81.26-1.235.257ZM5.4 15.427c.34.258.76.392 1.187.379.281.004.56-.053.817-.166l12.08-5.552a.954.954 0 0 0-.95-.731c-.211.004-.418.05-.61.137l-.044.017-4.334 1.411a.5.5 0 0 1-.374-.026L8.941 8.83h-.824l2.734 2.674a.5.5 0 0 1-.13.807l-2.89 1.411a.5.5 0 0 1-.374.026l-1.975-.643-.625.305.937.915a.5.5 0 0 1 0 .715l-.395.387Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sysAir_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSysAir;